{
  "internal_id": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "ID",
      "folder": "Header",
      "isShownByDefault": true,
    },
  },
  "land_id_unhyphenated": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Land ID",
      "folder": "Header",
      "isShownByDefault": true,
    },
  },
  "land_id_hyphenated": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Land ID Formatted",
      "folder": "Header",
      "isShownByDefault": true,
    },
  },
  "land_type": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Land Type",
      "folder": "Header",
      "isShownByDefault": true,
    },
  },
  "land_system": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Land System",
      "folder": "Header",
      "isShownByDefault": true,
    },
  },
  "centroid_latitude": {
    "source": "regulator",
    "domainType": "number",
    "ui": {
      "label": "Centroid Latitude",
      "folder": "Location",
    },
  },
  "centroid_longitude": {
    "source": "regulator",
    "domainType": "number",
    "ui": {
      "label": "Centroid Longitude",
      "folder": "Location",
    },
  },
  "geometry": {
    "source": "regulator",
    "domainType": "Geometry",
    "ui": {
      "label": "N/A",
      "folder": "N/A",
      "isNotRenderable": true,
    },
  },
}
